export enum ConversationUserIdentityType {
  userId = 'userId',
  anonymousExternalId = 'anonymousExternalId',
}

export type ConversationUserIdentityTypeType = keyof typeof ConversationUserIdentityType;
